module.exports = __webpack_public_path__ + "media/brand_logos/google-11e91c78.png";